var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vuestic-radio-button",
      class: _vm.computedClass,
      on: { click: _vm.onClick },
    },
    [
      _c(
        "div",
        {
          staticClass: "vuestic-radio-button__content",
          class: { active: _vm.isActive },
          on: {
            mousedown: function ($event) {
              _vm.focused = false
            },
            mouseup: function ($event) {
              _vm.focused = false
            },
          },
        },
        [
          _c("input", {
            staticClass: "vuestic-radio-button__input",
            attrs: { type: "radio", disabled: _vm.disabled },
            domProps: { checked: _vm.isActive },
            on: {
              focus: function ($event) {
                _vm.focused = true
              },
              mouseout: function ($event) {
                _vm.focused = false
              },
              blur: function ($event) {
                _vm.focused = false
              },
            },
          }),
          _vm._m(0),
        ]
      ),
      _c(
        "div",
        { staticClass: "vuestic-radio-button__slot-container" },
        [
          _vm._t("label", function () {
            return [_vm._v("\n      " + _vm._s(_vm.computedLabel) + "\n    ")]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vuestic-radio-button__icon" }, [
      _c("div", { staticClass: "vuestic-radio-button__icon-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }